/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { FauxUnavailableImage } from 'sarsaparilla';

import type { SearchResultItem } from '../../api/search/search.types';

import styles from './CardImage.module.scss';

interface CardImageProps {
    item: SearchResultItem;
    className?: string;
    unavailableImageClassName?: string;
}

export function CardImage({
    item,
    className,
    unavailableImageClassName,
}: CardImageProps) {
    if (item.preview_image_url) {
        return (
            <img
                src={item.preview_image_url}
                alt={item.name}
                className={cx(styles.img, className)}
            />
        );
    }

    return (
        <FauxUnavailableImage
            className={cx(styles.img, styles.unavailableImage, unavailableImageClassName)}
        />
    );
}
